import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatCurrencyMinor } from '@utils/formatCurrency';
export const Price = ({ amountMinor, currency }) => {
    const { i18n } = useTranslation();
    return _jsx("span", { children: formatCurrencyMinor(amountMinor, currency, i18n.language) });
};
export const TaxExclusion = ({ short = false, className }) => {
    const { t } = useTranslation();
    return _jsx(TaxText, { className: className, children: t(short ? 'tax.excludedShort' : 'tax.excluded') });
};
const TaxText = styled.span `
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.45;
  letter-spacing: 0;
`;
